import React, { Component } from 'react'
import { connect } from 'react-redux'
import { firebaseRef } from 'config'
import { routeActions } from 'react-router-redux'
import { userUpdated, releaseHijack } from 'actions/auth'
import { listenForUserbets, initialUserbetsLoaded } from 'actions/userbets'
import { currenciesReceived } from 'actions/currencies'
import { bookmakerListsChanged } from 'actions/bookmakerLists'
import { newsReceived } from 'actions/news'
import { logException } from 'utils/helpers'
import { identify } from 'utils/segment'
import { calculateTotalProfit } from 'utils/calculations'
import Navbar from 'components/Navbar'
import Topbar from 'components/Topbar'
import LoadingComponent from 'components/LoadingComponent'
import 'css/app.less'

let __startedAnalytics = false

class App extends Component {
  constructor(props) {
    super(props)
    this.onAuth = this.onAuth.bind(this)
    this.state = {
      authDone: false,
      bookmakerListsDone: false,
      currenciesDone: false,
      userbetsDone: false
    }
  }

  onAuth(data) {
    const { dispatch } = this.props
    if (data) {
      if (Object.keys(this.props.auth.user).length === 0) {
        firebaseRef
          .child('users')
          .child(data.uid)
          .once('value', snapshot => {
            if (!snapshot.exists()) {
              logException('User does not exist', {
                data
              })
              return
            }
            let userObject = snapshot.val()
            dispatch(userUpdated(Object.assign({}, userObject, {id: snapshot.key()})))
            Raven.setUserContext({
              email: userObject.email || 'facebookUser',
              id: data.uid,
              displayName: userObject.displayName || ''
            })
            firebaseRef.child('news').orderByChild('createdAt').startAt(userObject.lastLoginAt).once('value', snap => {
              let news = []
              if (snap.exists()) {
                snap.forEach(s => {
                  news.push(s.val())
                })
                dispatch(newsReceived(news))
                firebaseRef.child('users')
                  .child(data.uid)
                  .update({
                    lastLoginAt: Firebase.ServerValue.TIMESTAMP
                  })
              }
            })
            this.setState({authDone: true})
          })
        firebaseRef
          .child('users')
          .child(data.uid)
          .on('child_changed', snapshot => {
            dispatch(userUpdated({
              [snapshot.key()]: snapshot.val()
            }))
          })
        firebaseRef.child('userbets').orderByChild('user').equalTo(data.uid).once('value', snap => {
          let userbets = []
          snap.forEach(subsnap => {
            userbets.push(Object.assign({}, subsnap.val(), {id: subsnap.key()}))
          })
          dispatch(initialUserbetsLoaded(userbets))
          dispatch(listenForUserbets(data.uid))
          this.setState({userbetsDone: true})
        })
        firebaseRef.child('currencies').once('value', snap => {
          if (snap.exists()) {
            dispatch(currenciesReceived(snap.val()))
          }
          this.setState({currenciesDone: true})
        })
        firebaseRef.child('bookmakerLists').child(data.uid).on('value', snap => {
          if (snap.exists()) {
            dispatch(bookmakerListsChanged(snap.val()))
          } else {
            dispatch(bookmakerListsChanged({}))
          }
          if (!this.state.bookmakerListsDone) {
            this.setState({bookmakerListsDone: true})
          }
        })
      }
    }
    else {
      dispatch(routeActions.push('/login'))
    }
  };

  releaseHijack() {
    const { dispatch } = this.props
    dispatch(releaseHijack())
  }

  componentDidMount() {
    firebaseRef.onAuth(this.onAuth)
    this.updateAnalytics = () => {
      __startedAnalytics = true
      if (this.props.userbets.length > 0 && this.state.authDone && this.state.currenciesDone) {
        let settledBets = this.props.userbets.filter(b => b.status !== 1)
        identify(this.props.auth.user.id, {
          totalProfit: calculateTotalProfit(settledBets, this.props.currencies, 'USD'),
          bets: this.props.userbets.length
        })
      }
      setTimeout(this.updateAnalytics, 1000 * 60 * 30)
    }
  }

  componentWillUnmount() {
    firebaseRef.offAuth(this.onAuth)
  }

  componentDidUpdate() {
    this.checkAuthentication(this.props)
    if (this.props.userbets.length > 0 && this.state.currenciesDone && !__startedAnalytics)
      this.updateAnalytics()
  }

  checkAuthentication(props) {
    const { pathname } = props.location
    if (!pathname.match(/trial-ended/) && !(pathname.match(/me/)) && !(pathname.match(/subscribe/))) {
      const { user } = props.auth
      if (Object.keys(user).length > 0) {
        const { trialEndsAt, permissionLevel, hijacked } = user
        if (permissionLevel <= 0) {
          //if the user is not being hijacked redirect to subscribe
          if (trialEndsAt < Date.now() && hijacked === undefined) {
            const { dispatch } = props
            dispatch(routeActions.push('/trial-ended'))
          }
        }
      }
    }
  }

  render() {
    if (Object.keys(this.state).map(k => this.state[k]).reduce((a, b) => a && b) !== true)
      return <LoadingComponent />
    return (
      <div id="page-wrapper">
        <Navbar />
        <div id="content-wrapper">
          <Topbar user={ this.props.auth.user } />
          <div className="page-content">
            { this.props.auth.user.hijacked === true && (
              <div onClick={this.releaseHijack.bind(this)} className='alert alert-warning alert-hijack'>{ 'You are hijacking ' + this.props.auth.user.email + ', click here to release or refresh the page.' }</div>
              )
            }
            { React.cloneElement(this.props.children, {user: this.props.auth.user }) }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(state => state)(App)



/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/